export default __webpack_public_path__ + "static/media/texture.fe884342.png";